import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.USER);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const userService = {
  // Lấy profile đầy đủ
  getProfile: async () => {
    try {
      const response = await axios.get(`${API_URL}/profile`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thông tin profile'));
    }
  },

  // Lấy stats nhanh
  getStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/stats`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thống kê'));
    }
  }
};
